import React from 'react';
import LoginForm from '../components/LoginForm';

function LoginPage() {
    return (
        <div className="login-background" style={{ position: 'relative', flexDirection: 'column', justifyContent: 'flex-start', paddingTop: '5vh', overflow: 'hidden' }}>
            {/* Decorative square shape at bottom left */}
            <div style={{
                position: 'absolute',
                bottom: '-60px',
                left: '-60px',
                width: '400px',
                height: '300px',
                background: '#F0EBE8',
                borderRadius: '16px',
                zIndex: 0,
            }} />
            {/* Decorative rectangle shape at top right */}
            <div style={{
                position: 'absolute',
                top: '260px',
                right: '890px',
                width: '220px',
                height: '330px',
                background: '#F0EBE8',
                borderRadius: '24px',
                border: 0,
                zIndex: 0,
                transform: 'rotate(+20deg)',
            }} />
            <div style={{
                position: 'absolute',
                top: '260px',
                right: '200px',
                width: '320px',
                height: '330px',
                background: '#F0EBE8',
                borderRadius: '24px',
                border: 0,
                zIndex: 0,
                transform: 'rotate(+20deg)',
            }} />
            <div style={{
                position: 'absolute',
                top: '20px',
                right: '-69px',
                width: '320px',
                height: '330px',
                background: '#F0EBE8',
                borderRadius: '24px',
                border: 0,
                zIndex: 0,
                transform: 'rotate(+20deg)',
            }} />
    

            <div style={{ textAlign: 'center', marginBottom: '2.5rem', position: 'relative', zIndex: 1 }}>
                <span style={{ fontSize: '2.2rem', fontWeight: 700, letterSpacing: '2px', color: '#222' }}>EP-Scan</span>
            </div>
            <div className="login-box" style={{ position: 'relative', zIndex: 1 }}>
                <LoginForm />
            </div>
        </div>
    );
}

export default LoginPage;
